export default __webpack_public_path__ + "static/media/david8.b3bdcca1.jpg";